import { render } from "./HorizontalTab.vue?vue&type=template&id=00a3a77a&scoped=true"
import script from "./HorizontalTab.vue?vue&type=script&lang=js"
export * from "./HorizontalTab.vue?vue&type=script&lang=js"

import "./HorizontalTab.vue?vue&type=style&index=0&id=00a3a77a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a3a77a"]])

export default __exports__